import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchPublicCoreLocations } from "./FetchLocationAPI";

const initialState = {
  data: [],
  loading: false,
  error: null,
};

export const fetchPublicCoreLocationsAsync = createAsyncThunk(
  "PublicCoreLocations/fetch",
  // Accept optional payload with keyword
  async ({ keyword = "" } = {}, { rejectWithValue }) => {
    try {
      const data = await fetchPublicCoreLocations(keyword);
      const resp = data?.response;
      if (!resp) {
        throw new Error("Invalid response structure");
      }
      return resp;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const PublicCoreLocationsSlice = createSlice({
  name: "PublicCoreLocations",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchPublicCoreLocationsAsync.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchPublicCoreLocationsAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        state.error = null;
      })
      .addCase(fetchPublicCoreLocationsAsync.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || action.error.message;
      });
  },
});

export const selectPublicCoreLocations = (state) => state.publicCoreLocations.data;

export default PublicCoreLocationsSlice.reducer;